"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
const ExpenseRecordColumns_1 = require("./ExpenseRecordColumns");
function default_1({ roomId }) {
    const setSettlementTotalAmount = (0, recoil_1.useSetRecoilState)(settlementManageState_1.settlementTotalAmountState);
    const expenseRecordForm = (0, react_hook_form_1.useForm)({ mode: 'onChange' });
    const [revealContents, setRevealContents] = (0, react_1.useState)(false);
    const getExpenseRecordData = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.getData)(`/api/v1/room/${roomId}/settlement-manage/expense`)
            .then(res => {
            const { result } = res.data;
            if (!(result === null || result === void 0 ? void 0 : result.id)) {
                createExpenseRecordData();
            }
            const { total_withdrawable_amount, total_reward_amount } = result;
            setSettlementTotalAmount({ total_withdrawable_amount, total_reward_amount });
            expenseRecordForm.reset(result);
            setRevealContents(true);
        })
            .catch(err => {
            const { status } = err.response;
            if (status === 403)
                (0, errors_1.handle403Error)(err);
            else
                alert((0, errors_1.commonErrorMsg)(status));
        });
    });
    const createExpenseRecordData = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.postData)(`/api/v1/room/${roomId}/settlement-manage/expense`, {}).catch(err => {
            const { status } = err.response;
            if (status === 403)
                (0, errors_1.handle403Error)(err);
            else
                alert((0, errors_1.commonErrorMsg)(status));
        });
    });
    (0, react_1.useEffect)(() => {
        getExpenseRecordData();
    }, []);
    const { t } = (0, react_i18next_1.useTranslation)();
    // ? recordFileChoice
    // PRODUCTION_COST = 0
    // PACKAGING_COST = 1
    // DELIVERY_COST = 2
    // LABOR_COST = 3
    // RENT_COST = 4
    // DONATION_COST = 5
    // OTHER_COST_1 = 6
    // OTHER_COST_2 = 7
    const expenseRecordListArr = [
        {
            name: t('제작비'),
            recordField: 'production_cost',
            recordFileChoice: 0,
            detail: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { children: t('제작비') }), (0, jsx_runtime_1.jsx)("p", { children: t('작품 제작에 사용된 금액이에요') }), (0, jsx_runtime_1.jsx)("p", { children: t('예) 제작업체, 공장 송금 비용') })] })),
        },
        { name: t('포장비'), recordField: 'packaging_cost', recordFileChoice: 1 },
        { name: t('배송비'), recordField: 'delivery_cost', recordFileChoice: 2 },
        { name: t('인건비'), recordField: 'labor_cost', recordFileChoice: 3 },
        { name: t('임대료'), recordField: 'rent_cost', recordFileChoice: 4 },
        { name: t('기부금'), recordField: 'donation_cost', recordFileChoice: 5 },
        { name: t('기타 비용1'), recordField: 'other_cost_1', recordFileChoice: 6 },
        { name: t('기타 비용2'), recordField: 'other_cost_2', recordFileChoice: 7 },
    ];
    const { watch } = expenseRecordForm;
    const [isInputMode, setIsInputMode] = (0, react_1.useState)(false);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    if (!revealContents)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            flexDirection: maxWidth768 ? 'column' : 'row-reverse',
            gap: '10px 24px',
        } }, { children: [(0, jsx_runtime_1.jsxs)(_1.ExpenseRecordWrapper, Object.assign({ className: "surface-white" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "expense_record_title subtitle2 gray-80" }, { children: `🔒 ${t('비용 기록')}` })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "expense_record_grid" }, { children: [(0, jsx_runtime_1.jsx)(ExpenseRecordColumns_1.TopColumns, {}), (0, jsx_runtime_1.jsx)(ExpenseRecordColumns_1.TotalSettlementColumns, { watch: watch, isInputMode: isInputMode }), expenseRecordListArr.map((recordItem, index) => ((0, jsx_runtime_1.jsx)(ExpenseRecordColumns_1.RecordInputColumns, { recordItem: recordItem, expenseRecordForm: expenseRecordForm, isInputMode: isInputMode, roomId: roomId }, `expense_record_input_${recordItem.name}_${index}`))), (0, jsx_runtime_1.jsx)(ExpenseRecordColumns_1.NetProfitColumns, { watch: watch, isInputMode: isInputMode })] })), (0, jsx_runtime_1.jsx)(_1.ExpenseRecordRegister, { isInputMode: isInputMode, setIsInputMode: setIsInputMode, expenseRecordForm: expenseRecordForm, roomId: roomId })] })), (0, jsx_runtime_1.jsx)(_1.ExpenseRecordGuide, {})] })));
}
exports.default = default_1;
